// extracted by mini-css-extract-plugin
module.exports = {"section-header":"section-tree_section-header__2_--t","section-title":"section-tree_section-title__a04MP"};